import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { VENDOR_PROFILE_KEY } from '@/features/vendor-profile/hooks';
import { fetch_vet_details, save_vet_details } from './api';
import type { VetDetailsRequest, VetDetailsResponse } from './types';

const KEY = ['module-details', 'vet'] as const;

export function use_save_vet_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: VetDetailsRequest) => save_vet_details(input),
    onSuccess: (data: VetDetailsResponse) => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
      // KYC is back in review — refetch the profile so the status banner shows it.
      if (data.reverification_required) qc.invalidateQueries({ queryKey: VENDOR_PROFILE_KEY });
    },
  });
}

export function use_vet_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_vet_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
